// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import DisableFileUploadsController from './disable_file_uploads_controller';
application.register('disable-file-uploads', DisableFileUploadsController);

import HelloController from './hello_controller';
application.register('hello', HelloController);

import ThemeController from './theme_controller';
application.register('theme', ThemeController);
